import { connect } from 'react-redux';
import { cancelQuoteByWorkspaceThunk } from 'state/quotes/quotes.thunks';
import { getQuoteType } from 'state/quotes/selectors';
import { isQuoteTypeTradable } from 'state/quotes/utils';
import {
  getFormQuoteId,
  getFormQuoteRequestStartingTimeInMillis,
  getFormQuoteResult,
  getQuoteSolvingMode,
  isQuoteAcked,
} from 'state/selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';
import type { QuoteWorkspaceType } from 'state/workspaces/model';

export interface OwnProps {
  tabId: string;
  workspaceType: QuoteWorkspaceType;
}

export interface StateProps {
  quoteRequestStartingTimeInMillis: number;
  estimatedQuotingDurationInMillis?: number;
  solvingMode?: string;
  isTradable: boolean;
  isQuoteAcked: boolean;
}

export interface DispatchProps {
  onQuoteCancelled(): void;
}

export type QuotingState = StateProps & OwnProps & DispatchProps;

const mapStateToProps = (state: AppState, { tabId, workspaceType }: OwnProps): StateProps => {
  const quoteResult = getFormQuoteResult(state, workspaceType, tabId);
  const quoteId = getFormQuoteId(state, workspaceType, tabId);
  const quoteType = getQuoteType(state, quoteId);
  const quoteRequestTimeInMillis = getFormQuoteRequestStartingTimeInMillis(state, workspaceType, tabId)!;
  const solvingMode = getQuoteSolvingMode(state, tabId);

  return {
    quoteRequestStartingTimeInMillis: quoteRequestTimeInMillis,
    estimatedQuotingDurationInMillis: quoteResult?.estimatedQuotingDurationInMillis!,
    isTradable: isQuoteTypeTradable(quoteType),
    solvingMode,
    isQuoteAcked: isQuoteAcked(state, workspaceType, tabId),
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch, { tabId, workspaceType }: OwnProps): DispatchProps => ({
  onQuoteCancelled() {
    dispatch(cancelQuoteByWorkspaceThunk(tabId, workspaceType));
  },
});

export const connectQuoting = connect(mapStateToProps, mapDispatchToProps);
